/**
 * 推广/邀请相关接口
 * 对应 Apipost: 用户端 > 推广中心
 */

import { http } from "@/http/axios";

// ==================== 类型定义 ====================

/** 邀请二维码数据 */
export interface QrCodeData {
  user_id: number;
  invite_code: string;
  qrcode_url: string;
  qrcode_base64: string;
  nickname: string;
  avatar: string;
}

/** 推广团队成员（邀请记录） */
export interface TeamMember {
  uid: number;
  nickname: string;
  avatar: string;
  phone: string;
  spread_time: string; // 绑定时间
}

/** 团队列表响应 */
export interface TeamListResponse {
  code: number;
  message: string;
  data: {
    total: number;
    page: number;
    limit: number;
    list: TeamMember[];
  };
}

// ==================== 接口调用 ====================

/**
 * 接口1：获取邀请二维码
 * GET /home/user/spread/qrcode
 * 返回当前用户的邀请二维码、邀请码、头像等信息
 */
export async function fetchInviteQrCode(): Promise<QrCodeData> {
  console.log("[API] 获取邀请二维码:", "/home/user/spread/qrcode");

  const res = await http.get<{ code: number; message: string; data: QrCodeData }>("/home/user/spread/qrcode");

  if (res.data.code !== 200) {
    throw new Error(res.data.message || "获取邀请二维码失败");
  }

  return res.data.data;
}

/**
 * 接口2：推广团队列表（邀请记录）
 * GET /home/user/spread/team?page={page}&limit={limit}
 * 获取当前用户推广的团队成员列表（一级推广）
 */
export async function fetchTeamList(params?: {
  page?: number;
  limit?: number;
}): Promise<TeamListResponse["data"]> {
  console.log("[API] 获取推广团队列表:", "/home/user/spread/team", params);

  const res = await http.get<TeamListResponse>("/home/user/spread/team", { params });

  if (res.data.code !== 200) {
    throw new Error(res.data.message || "获取推广团队失败");
  }

  return res.data.data;
}

/**
 * 接口3：绑定推荐人
 * POST /home/user/spread/bind-parent
 * 通过邀请码绑定推荐人关系
 */
export async function bindParent(code: string): Promise<{ message: string }> {
  console.log("[API] 绑定推荐人:", "/home/user/spread/bind-parent", { code });

  const res = await http.post<{ code: number; message: string; data: { message: string } }>("/home/user/spread/bind-parent", { code });

  if (res.data.code !== 200) {
    throw new Error(res.data.message || "绑定推荐人失败");
  }

  return res.data.data;
}
